<!--名著导读-->
<template>
    <div class="guide-nav-content">
        <!-- 阅读拓展首页 -->
        <div class="guide-ext-container" v-show="showMode==='readMuseum'">
            <div class="head-container">
                <div class="left-head-container" @click="backReadMuseum">
                    <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">名著导读</div>
                <div class="left-head-container">
                </div>
            </div>
            <!--搜索-->
            <el-row class="mt0" style="padding:0 10px 0 10px;box-sizing: border-box">
                <el-col :span="5" class="mb0">
                    <el-form-item label="主题">
                        <el-select clearable @change="pageList(null)" v-model="queryParams.bookItem" placeholder="请选择主题">
                            <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                       :value="item.itemId" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="1" class="mb0"></el-col>
                <el-col :span="5" class="mb0">
                    <el-form-item label="学段">
                        <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学科">
                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="1" class="mb0"></el-col>
                <el-col :span="5" class="mb0">
                    <el-form-item label="年级段">
                        <el-select clearable @change="pageList(null)" v-model="queryParams.bookGrade" placeholder="请选择年级">
                            <el-option v-for="item in itemGradeList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="1" class="mb0"></el-col>
                <el-col :span="6" class="mr0 mb0">
                    <el-form-item class="pull-right">
                        <el-input v-model="queryParams.bookName" placeholder="请输入名称" class="input-with-select">
                            <template #append>
                                <el-button @click="pageList(null)" type="primary" icon="el-icon-search" style="background-color: #ff7f2e;color: #fff"/>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--   书目列表  -->
            <el-scrollbar class="book-page-container">
                <div class="read-book-container">
                    <div class="read-book-item" v-for="item in dataList" :key="item">
                        <div class="read-book-one" @click="viewBook(item)">
                            <div class="read-book-img">
                                <img alt="" class="img-100" :src="item.bookCover">
                            </div>
                            <div class="read-book-title">
                                {{ item.bookName }}
                            </div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
            <div class="page-container" v-if="dataList&&dataList.length>0">
                <pageTag :background="true"
                         :pageSizes="[10, 20, 30]"
                         v-show="total > 0"
                         :total="total"
                         v-model:page.sync="queryParams.pageNum"
                         v-model:limit.sync="queryParams.pageSize"
                         @pagination="pageList" />
            </div>
        </div>
        <!-- 书目详情 -->
        <div class="guide-nav-content" v-show="showMode==='readBook'">
            <read-book-info :item-id="this.bookId"  @back-book-page="backBookPage"/>
        </div>
    </div>
</template>
<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import readBookInfo from "@/components/newMuseum/read/readBookInfo.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {pageBook} from "@/api/admin/book";
import {queryDict} from "@/api/admin/public";
import {listItem} from "@/api/admin/item";
export default {
    name:'readingGuide',
    components:{pageTag, dataEmpty ,readBookInfo},
    props:{
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.showMode = 'readMuseum';
            this.queryParams.pageNum = 1;
            this.pageList()
        },
    },
    mounted() {
        this.pageList()
        this.getQueryDict();
        this.queryItemList();
    },
    data() {
        return {
            showMode:'readMuseum',
            timestampDate,
            timestampToTime,
            total: 0,
            pageCount:0,
            dataList: [],
            periodList:[],
            gradeList:[],
            itemList:[],
            itemGradeList:'',
            queryParams: {
                bookName:'',
                bookItem:'',
                bookGrade:'',
                periodKey:'',
                gradeKey:'',
                pageNum: 1,
                pageSize: 10,
            },

            bookId:'',
        }
    },
    methods: {
        queryItemList(){
            listItem({ itemType: 2 }).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageList(null)
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'grade_period' }).then(res => {
                this.itemGradeList = res.data.data;
            })
        },
        pageList(){
            this.dataList = []
            pageBook(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        backReadMuseum(){
            this.$emit('back-read-museum', "homePage");
        },
        /*查看书目详情*/
        viewBook(item){
            this.bookId = item.bookId;
            this.showMode = 'readBook';
        },
        /*详情返回分页*/
        backBookPage(val){
            this.showMode = val;
        }
    }
}
</script>
<style scoped>
.guide-nav-content{
    width: 100%;
    height: auto;
}
.guide-ext-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.head-container{
    flex-shrink: 0;
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.book-page-container{
    flex: 1;
    min-height: 0;
    width: 100%;
}
.read-book-container{
    width: 100%;
    height: auto;
    padding: 20px 0 10px 0;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap!important;
}
.read-book-item{
    width: 20%;
    height: 300px;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
}
.read-book-one{
    width: 100%;
    height: 100%;
    border: 1.5px solid #f1f1f1;
    border-radius: 8px;
    overflow: hidden;
}
.read-book-one:hover{
    border: 1.5px solid #ff7f2e!important;
    color: #ff7f2e!important;
    font-weight: bold;
}
.read-book-img{
    width: 100%;
    height: 260px;
    position: relative;
}
.read-book-title{
    height: 24px;
    font-size: 16px;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 显示省略符号来代表被修剪的文本 */
    padding: 0 2px 2px 2px;
    cursor: pointer;
    line-height: 24px;
}
.page-container{
    flex-shrink: 0;
    display: grid;
    place-items: center;
    width: 100%;
    height: 40px;
    padding-top: 15px;
    box-sizing: border-box;
}

</style>